











import {
  Component, Vue, Provide, Prop,
} from 'vue-property-decorator';

    @Component({
      components: {
      },
    })
export default class extends Vue {
        @Prop() titleData!: string;

        private created() {
          console.log(this.titleData);
        }

        private back() {
          this.$router.go(-1);
        }
}
